import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import Suppliers from './pages/Suppliers';
import SupplierFinance from './pages/SupplierFinance';
import Wholesalers from './pages/Wholesalers';
import Billing from './pages/Billing';
import Devices from './pages/Devices';
import Support from './pages/Support';
import Audit from './pages/Audit';
import Plans from './pages/Plans';
import Settings from './pages/Settings';
import AppBanners from './pages/AppBanners';
import AppCuisines from './pages/AppCuisines';
import AppReviews from './pages/AppReviews';
import AppUsers from './pages/AppUsers';
import AppUserDetail from './pages/AppUserDetail';
import Managers from './pages/Managers';
import ManagerDetail from './pages/ManagerDetail';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/:id" element={<TenantDetail />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/wholesalers" element={<Wholesalers />} />
        <Route path="/supplier-finance" element={<SupplierFinance />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/managers" element={<Managers />} />
        <Route path="/managers/:id" element={<ManagerDetail />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/support" element={<Support />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/app/banners" element={<AppBanners />} />
        <Route path="/app/cuisines" element={<AppCuisines />} />
        <Route path="/app/reviews" element={<AppReviews />} />
        <Route path="/app/users" element={<AppUsers />} />
        <Route path="/app/users/:id" element={<AppUserDetail />} />
        <Route path="*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
